import { Flag } from "lucide-react";
import type { AiRiskUiBand } from "../../types/aiSuggestion";

type FlagIconProps = {
  readonly band: AiRiskUiBand;
  readonly className?: string;
  /** Solid fill reads like a control; outline is better in dense lists next to actions. */
  readonly filled?: boolean;
};

const bandClass: Record<AiRiskUiBand, string> = {
  legal: "text-risk-legal",
  business: "text-risk-business",
  exec: "text-risk-exec",
  red: "text-risk-strip-red",
  amber: "text-risk-strip-amber",
  green: "text-risk-strip-green",
};

export const FlagIcon = ({
  band,
  className = "",
  filled = true,
}: FlagIconProps) => (
  <Flag
    className={`h-4 w-4 shrink-0 ${bandClass[band]} ${className}`.trim()}
    strokeWidth={2}
    aria-hidden
    fill={filled ? "currentColor" : "none"}
  />
);
